import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are agreement to rules?</div>
        <p>
          By entering this Giveaway, the Entrant (“You”) agrees to abide by the
          Sponsor's Official Rules and decisions, which are fully and
          unconditionally binding in all respects. The Sponsor reserve the right
          to refuse, withdraw, or disqualify any entry at any time at the
          Sponsor’s sole discretion.By entering this Giveaway the You represents
          and warrants that You are eligible to participate based on eligibility
          requirements explained in the Official Rules. You also agree to accept
          the decisions of the Sponsor as final and binding as it relates to the
          content of this T-Shirt Giveaway.
        </p>
      </div>
    </div>
  );
};

export default Q2;
